<template>
        <div class="exampleCode">
            <!-- <audio src="https://resource-iu.singularity-ai.com/aigc/aigc-code/sky-code/kkk.mp3" controls="controls" id="keyTyping" muted="true" hidden></audio>
            <audio src="https://resource-iu.singularity-ai.com/aigc/aigc-code/sky-code/bob.mp3" controls="controls" id="ding" muted="true" hidden></audio>
            <audio src="https://resource-iu.singularity-ai.com/aigc/aigc-code/sky-code/buling.mp3" controls="controls" id="buling" muted="true" hidden></audio> -->
            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                v-for="item in demoList"
                :key="item.file_name"
                :label="item.file_name"
                :name="item.file_name"
                >
                <span slot="label"><i class="label-icon el-icon-s-open"></i>{{item.file_name}}</span>
                <div class="demolistContent tw-flex" :style="{height: (lineNumber + 2) *24 +'px'}">
                    <div class="columnNum">
                        <div v-for="i in lineNumber" :key="i" class="pr-2">{{i}}</div>
                    </div>
                    <div class="codeContent">
                        <div class="f4 contentBox">
                            <pre v-if = "(!full && inShowCnt < inTotal && !full) " v-highlight class="f4"><div v-for="(s, index) in code_input" :key="s + index"><code v-if = "(inShowCnt <= inTotal)" class="code-editor-line-mktg d-inline-block js-type-row color-bg-accent" data-type-row-delay="0" >{{s}}</code><span v-if="!finShowInput" class="blinkCursor"></span></div></pre> 
                            <pre v-if = "(!full && inShowCnt >= inTotal)" v-highlight class="f4" ><code class="code-editor-line-mktg d-inline-block js-type-row color-bg-accent" data-type-row-delay="0" >{{fullShowContent}}</code></pre>
                            <pre v-if = "(full && fullShowContent.length > 0 && fullShowContent.length < inTotal)" class="f4" ><code class="code-editor-line-mktg d-inline-block js-type-row color-bg-accent" data-type-row-delay="0" >{{fullShowContent}}</code></pre>
                            <pre v-if = "(full && fullShowContent.length >= inTotal)" v-highlight class="f4" ><code class="code-editor-line-mktg d-inline-block js-type-row color-bg-accent" data-type-row-delay="0" >{{fullShowContent}}</code></pre>
                            <pre v-if="finShowGen" v-highlight class="f4"><div v-for="(s, index) in code_generate" :key="s + index"><code class="code-editor-line-mktg d-inline-block js-type-row color-bg-accent code-editor-line-suggested-mktg row-is-visible" data-type-row-delay="0" :style="{visibility: finShowGen?'visible':'visible'}">{{s}}</code></div></pre> 
                            <pre v-else class="f4"><div v-for="(s, index) in code_generate" :key="s + index"><code class="code-editor-line-mktg d-inline-block js-type-row color-bg-accent " :class="((finShowGen) && 'highlcode-editor-line-suggested-mktgight' || (finShowGen)&&'row-is-visible') " data-type-row-delay="0"  :style="{visibility: finShowGen?'visible':'visible', color: '#808080'}">{{s}}</code></div></pre> 
                        </div>
                        
                    </div>
                </div>
                </el-tab-pane>
            </el-tabs>
        </div>
</template>

<script>
// let  keyTyping = document.getElementById('keyTyping');
// let  ding = document.getElementById('ding');
// let  buling = document.getElementById('buling');
export default {
name: 'DomeCode',
    data() {
        return {
            demoList: [],
            activeNameIndex: 0,
            activeName: '',
            language: "",
            full:false,
            interval: 100,
            showBlinkCursor: true,
            finShowGen : false,
            finShowInput : false,
            fullShowContent:"",
            showContent: '', // 正在显示的 处理过的输入内容
            code_input : [], // 前置的输入
            code_generate: [], // 正在显示的 处理过的输出内容
            lineNumber: 0, // 正在显示的 总行数
            timer: null
        };
    },
    props: {
        demoListPor: {
            type: Array
        },
    },
    created() {
        this.demoList = this.demoListPor
        // 处理数据
        this.activeName = this.demoList[0].file_name
        this.fullShowContent = ""
        this.code_generate = []
        this.finShowGen = false
        this.finShowInput = false
        let data = this.demoList[0] 
        let l1 = data.code_input.split('\n').length;
        let l2 = data.code_generate.split('\n').length;
        this.full = false
        this.code_input = [] 
        this.code_generate = []
        this.lineNumber = l1 + l2 
        this.language = this.languageMapping(data.language)
        // console.log("language ", this.language)
        // console.log(this.lineNumber);
        // console.log(this.code_generate);

// 情况1-情况3: 上面没有颜色
        this.dayinzi(this.activeNameIndex)
        // console.log(this.demoList);
    },
    // mounted() {
    //     keyTyping = document.getElementById('keyTyping');
    //     ding = document.getElementById('ding');
    //     buling = document.getElementById('buling');
    // },
    methods: {
        // 音频开关
        audioPlay(ins, interval) {
            try {
                ins.play().then(() => {
                    console.log("play")
                }).catch(err => console.log(err)) ;
                setTimeout(() => {
                    ins.pause();
                    ins.currentTime = 0;
                } , interval);
            }catch {
                return
            }
        }
        , 
        // playKeyTyping (interval) {
        //     keyTyping = document.getElementById('keyTyping');
        //     this.audioPlay(keyTyping, interval)
        // },
        // playDing (interval) {
        //     ding = document.getElementById('ding');
        //     this.audioPlay(ding, interval)
        // },
        // playBuling (interval) {
        //     buling = document.getElementById('buling');
        //     this.audioPlay(buling, interval)
        // },
        // playInit () {
            
        // },
        domeCodeChildMethods() {
            let that = this
            if (that.showContent.length == 0) {
            // that.showBlinkCursor = true
            this.dayinzi(that.activeNameIndex)
            } else {
                console.log('有数据了');
            }
        },
        domeCodeChildMethodsSec() {
            this.showBlinkCursor = true
            this.finShowGen = false
            this.showContent = ''
            this.code_generate = []
        },
        // 情况1: 开始时 上面没有颜色
        handleClick(tab) {
            // this.keyTypingAudio = keyTyping
            // this.dingAudio = ding
            // this.bulingAudio = buling
            // this.playInit()
            let that = this
            this.activeName = tab.name
            this.activeNameIndex = tab.index
            this.finShowGen = false
            this.finShowInput = false
            this.showBlinkCursor = true
            let data = this.demoList[tab.index]
            this.full = false
            let l1 = data.code_input.split('\n').length;
            let l2 = data.code_generate.split('\n').length; 
            this.code_generate = []
            this.code_input = ["",]
            this.lineNumber = l1 + l2 
            this.showContent = ''
            this.language = this.languageMapping(data.language)
            clearInterval(this.timer);
            this.timer = null
            this.$forceUpdate()
            this.dayinzi(that.activeNameIndex)
        },
        
        // 情况3: 上面一部分先出来，其他逐个出来
        languageMapping(lang) {
            let mm = {
                "cpp": "C++",
                "python": "Python",
            }
            let language = mm[lang]
            console.log(language)
            return language
        }, 
        dayinzi(val) {
            // console.log(this.keyTypingAudio, this.dingAudio, this.bulingAudio)
            let that = this
            // console.log(val);
            this.full = false
            let data = this.demoList[val]
            this.$forceUpdate()
            let suplementIndex = 0;
            let supplementLines = data.code_generate.split('\n');
            let allSuplementCnt = supplementLines.length

            let inputShowContents = data.code_input.split('\n');
            // console.log(inputShowContents)
            this.code_input = ["",]
            this.code_generate = []
            this.inTotal = data.code_input.length
            this.inShowCnt = 0
            this.allContent = ""
            this.fullShowContent = ""
            // 每一行
            let lineIdx = 0;
            let strIdx = 0;
            let genWait = false
            var myFunction = function () {
                clearInterval(that.timer);
                
                // 每一行
                if (lineIdx < inputShowContents.length && (strIdx < inputShowContents[lineIdx].length || inputShowContents[lineIdx].length == 0)) {
                    let lineContent = inputShowContents[lineIdx]
                    let step = Math.round(Math.random() * 10 + 10);
                    that.interval = step * 20;
                    // console.log(that.interval);
                    // that.playKeyTyping(that.interval)
                    let subS = lineContent.substring(strIdx, strIdx + step);
                    that.code_input[lineIdx] +=  subS;
                    that.inShowCnt += subS.length
                    that.fullShowContent += subS
                    // console.log(subS);
                    // console.log(that.fullShowContent);
                    // console.log("in cnt ", that.inShowCnt, " total cnt ", that.inTotal)
                    strIdx += step;
                    if (strIdx >= lineContent.length) {
                        lineIdx += 1;
                        that.inShowCnt += 1 // 这一个是换行的 1
                        that.fullShowContent += "\n"
                        strIdx = 0;
                        if (lineIdx < inputShowContents.length) {
                            that.code_input.push("")
                            that.interval += 50;
                        }
                    }
                    that.timer = setInterval(myFunction, that.interval);
                } else if (suplementIndex < allSuplementCnt){
                    that.finShowInput = true
                    if (!genWait) {
                        genWait = true;
                        that.interval = 300;
                        that.timer = setInterval(myFunction, that.interval);
                    } else {
                        // that.playDing(that.interval)
                        that.interval = 300;
                        that.code_generate.push(supplementLines[suplementIndex]);
                        // console.log(that.code_generate)
                        suplementIndex += 1;
                        that.timer = setInterval(myFunction, that.interval);
                    }
                } else {
                    that.finShowGen = true;
                    // that.playBuling(1000)
                }
            }
            that.timer = setInterval(myFunction, 1);
            
        }
    },
    destroyed() {
      //离开页面时删除该监听
      clearInterval(window.timer);
    }
};
</script>

<style scoped lang="less">
    .exampleCode{
        width: 100%;
        // height: 544px;
        height: auto;
        border: 1px solid #30363d;
        border-radius: 8px; 
        background: #24292f;
        margin: 0 20px;
        font-size: 16px;
        text-align: left;
        .label-icon {
            margin-right: 4px;
            width: 16px;
            height: 16px;
        }
        .demolistContent {
            .columnNum {
                text-align: right;
                color: #6e7681;
                .pr-2 {
                    padding-right: 8px;
                }
                
            }
            .codeContent{
                flex: 1;
                overflow-x: auto;
                .code-editor-line-mktg {
                    // display: inline-block;
                    border-left: 2px solid #24292f;
                }
                .code-editor-line-suggested-mktg {
                    border-color: #1f6feb;
                    background-color: rgba(56, 139, 253, .15);
                    display: inline-block;
                    padding: 0 !important;
                }
                .contentBox {
                    white-space: pre-wrap;
                    // white-space: pre-line;
                }

                .blinkCursor {
                    animation: Blink 1s ease-in 0s infinite;
                }

                @keyframes Blink {
                    0% {
                        opacity: 0;
                    }
                    100% {
                        opacity: 1;
                    }
                }
                .row-is-visible {
                    animation: row-reveal 800ms ease-out forwards;
                }
                @keyframes row-reveal{
                    0%,40%{opacity:0;transform:translateY(7px)}
                    100%{opacity:1}
                }
            }
        }
    }
</style>
<style lang="less">
    .el-tabs--border-card {
        border-radius: 8px;
        background: #24292f;
        border: none;
        box-shadow: none;
    }
    .el-tabs--border-card>.el-tabs__header {
        background-color: #0d1117;
        border-bottom: 1px solid #30363d;
        border-top-left-radius: 8px; 
        border-top-right-radius: 8px; 
        margin: 0;
        padding: 8px 8px 0 8px;
    }
    .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        border-bottom: 0 !important;
    }
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        color: #fff;
        background-color: #24292f;
        border-color: #30363d;
        border-radius: 6px 6px 0 0;
        margin: 0;
        border-bottom: 0;
    }
    .el-tabs--border-card>.el-tabs__header .el-tabs__item:hover {
        color: #FFf !important;
    }
    .hljs {
        display: inline-block;
        padding: 0;
        background: transparent;
    }
    .hljs-keyword, .hljs-function, .hljs-change, .hljs-winutils, .hljs-flow, .lisp .hljs-title, .clojure .hljs-built_in, .nginx .hljs-title, .tex .hljs-special, .hljs-header, .hljs-attribute, .hljs-symbol, .hljs-symbol .hljs-string, .hljs-tag .hljs-title, .hljs-value, .alias .hljs-keyword:first-child, .css .hljs-tag, .css .unit, .css .hljs-important {
        color: #ff7b72;
    }
</style>
